import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.scss";

type SidebarNavLinkProps = {
  text: string;
  link: string;
  classes: string;
  icon: ReactNode;
};

const SidebarNavLink = ({ text, link, icon, classes }: SidebarNavLinkProps) => {
  const location = useLocation();
  // const currentLang = "en"; // Replace with logic to detect language dynamically, if needed.

  const isActive =
    (link === "/" && location.pathname === `/`) ||
    (link !== "/" && location.pathname.startsWith(`${link}`));

  return (
    <Link
      to={link}
      className={`sidebar-nav-link ${classes} ${isActive ? "active" : "inactive"}`}
    >
      {icon}
      <p className="text hidden-lg">{text}</p>
    </Link>
  );
};

export default SidebarNavLink;
